<script>
    export let x;
    export let y;
    export let tx;
    export let ty;
    export let l1x;
    export let l1y;
    export let l2x;
    export let l2y;
    export let step;
    export let scale;
    export let className;
    export let cw;
    export let ch;
    export let vl;

    let cx;
    let cy;
    let lscale;

    let lWidth;
    let lHeight;
    let left;
    let right;
    let top;
    let bottom;
    let hVisible;
    let vVisible;
    let visible;

    $: cx = step < 2 || step > 4
        ? x * step
        : step === 2
            ? 2 * (x - l1x)
            : 4 * (x - l2x);

    $: cy = step < 2 || step > 4
        ? y * step
        : step === 2
            ? 2 * (y - l1y)
            : 4 * (y - l2y);

    $: lscale = scale / step;
    $: lWidth = 40 * step;
    $: lHeight = 40 * step;
    $: left = x * scale + tx;
    $: right = left + lWidth * lscale;
    $: top = y * scale + ty;
    $: bottom = top + lHeight * lscale;
    $: hVisible = left < cw && right > 0;
    $: vVisible = top < ch && bottom > 0;
    $: visible = hVisible && vVisible;

    let bigSquares = [];
    let mediumSquares = [];
    let smallSquares = [];

    for (let i = 0; i < 10; i++) {
        bigSquares.push({
            x: Math.random() * 30,
            y: Math.random() * 30,
            rotate: Math.random() * 90,
            step: i
        });
    }

    for (let i = 0; i < 40; i++) {
        mediumSquares.push({
            x: Math.random() * 35,
            y: Math.random() * 35,
            rotate: Math.random() * 90,
            step: i
        });
    }

    for (let i = 0; i < 50; i++) {
        smallSquares.push({
            x: Math.random() * 38,
            y: Math.random() * 38,
            rotate: Math.random() * 90,
            step: i
        });
    }
</script>

<div
        class="block {className}"
        style="
            transform: {
                !visible ? '' :
                    step <= 4
                    ? 'translate(' + cx + 'px, ' + cy + 'px)'
                    : 'translate(' + left + 'px, ' + top + 'px) scale(' + lscale + ')'
            };
            will-change: { step > 4 ? 'transform' : '' };
            display: { visible ? '' : 'none' };
        "
>
    <div style="display: {vl >= 1 ? '' : 'none'}">
        {#each bigSquares as item}
            <div
                style="
                    transform: {'translate(' + item.x * step + 'px, ' + item.y * step + 'px) rotate(' + item.rotate + 'deg)'};
                    width: {step * 0.35}px;
                    height: {step * 0.35}px;
                    display: {scale >= 3 + 0.1 * item.step ? 'block' : 'none'}
                "
                data-scale="{scale}"
                data-step="{item.step}"
                data-res="{3 + 0.1 * item.step}"
            ></div>
        {/each}
    </div>
    <div style="display: {vl >= 2 ? '' : 'none'}">
        {#each mediumSquares as item}
            <div
                style="
                    transform: {'translate(' + item.x * step + 'px, ' + item.y * step + 'px) rotate(' + item.rotate + 'deg)'};
                    width: {step * 0.15}px;
                    height: {step * 0.15}px;
                    display: {scale >= 9 + 0.15 * item.step ? 'block' : 'none'}
                "
            ></div>
        {/each}
    </div>
    <div style="display: {vl >= 1 ? '' : 'none'}">
        {#each smallSquares as item}
            <div
                style="
                    transform: {'translate(' + item.x * step + 'px, ' + item.y * step + 'px) rotate(' + item.rotate + 'deg)'};
                    width: {step * 0.05}px;
                    height: {step * 0.05}px;
                    display: {scale >= 3 + 0.2 * item.step ? 'block' : 'none'}
                "
            ></div>
        {/each}
    </div>
    <slot />
</div>
